/* eslint-disable eqeqeq */
import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import ImageUploader from "../ImageUploader/index"
import { Checkbox, ButtonGroup, Button } from "@tencent/spaui"
import $ from "jquery"

/**
 * @class
 */
class QualificationUploader extends PureComponent {
  constructor(props) {
    super(props)

    this.onChangeOptionalVal = this.onChangeOptionalVal.bind(this)
  }

  componentDidMount() {
    const data = this.props.data
    if (data.certification_relation_type == "optional") {
      this.onChangeOptionalVal("", this.props.data.code_checked)
    }
  }

  /*
   * 判断浏览器是否支持H5
   */
  isSupportH5() {
    return "draggable" in document.createElement("span")
  }

  /**
   * 改变选择一种资质上传的选项
   */
  onChangeOptionalVal(event, val) {
    this.props.onChangeChosen(event, val, this.props.data, this.props.industry_id)
  }

  genQualificationComp(data) {
    const { imageUploaderProps, multiCheckBoxStyle = { float: "right" } } = this.props
    let subComponent = [],
      subComponent2 = [],
      code,
      codeData,
      inputId,
      showError = false,
      imgData,
      lack = false,
      max = 0

    const qualiInfoComponent = []
    // const imgs = this.state.imgs;
    const props = this.props
    const industryId = props.industry_id

    // 取每个资质的第一页, 放到一起
    function getImgData(images) {
      let res = [],
        item = {}

      if (images) {
        for (let i in images) {
          item = images[i] || {}
          if (item.data && item.data.length > 0) {
            res.push({
              url: item.data[0].image_url,
              image_id: item.data[0].image_id,
              id: item.id,
            })
          }
        }
      }

      return res
    }

    // 取所有资质的所有页
    function getMultiPageImgData(images) {
      let res = []

      if (images) {
        for (let i in images) {
          if (images[i].data && images[i].data.length > 0) {
            for (let j in images[i].data) {
              res.push({
                url: images[i].data[j].image_url,
                id: images[i].data[j].id,
                image_id: images[i].data[j].image_id,
              })
            }
          }
        }
      }

      return res
    }

    function getOneCertificationImgData(images_i) {
      let res = []
      if (images_i.data && images_i.data.length > 0) {
        for (let i in images_i.data) {
          res.push({
            url: images_i.data[i].image_url,
            image_id: images_i.data[i].image_id,
            id: images_i.data[i].id,
          })
        }
      }

      return res
    }

    // 行业资质
    subComponent = []

    let multiPageCheckComp = "",
      isMultiPage = false,
      imageData = {},
      isRange = true,
      editDisabled,
      limit

    const inputFileStyle = {
      opacity: "0",
      display: "none",
      width: 0,
      height: 0,
    }

    const appendInputDOM = (_inputId, _code) => {
      let idArr = [],
        inputIdArr = [],
        findEmptyInput = false,
        id = _inputId

      const dom = $("<input type='file' name='img' id='" + _inputId + "' />")

      dom.on("change", (e) => this.props.onUploaderFileChange(e, _code, data, industryId))
      dom.css(inputFileStyle)

      // 如果是同一份资质，不同的页，看下是不是有空的可用的input，直接拿来用
      if ($("body").children("input").length > 0) {
        for (let i = 0; i < $("body").children("input").length; i++) {
          const item = $("body").children("input")[i]
          if ($("#" + item.id)[0].files.length == 0) {
            idArr = item.id.split("_")
            inputIdArr = id.split("_")

            // 非range
            if (idArr.length == 4 && inputIdArr.length == 4) {
              idArr.pop()
              inputIdArr.pop()
              if (idArr.join("_") == inputIdArr.join("_")) {
                id = item.id
                findEmptyInput = true
              }
              // range
            } else if (idArr.length == 3 && inputIdArr.length == 3) {
              idArr.pop()
              inputIdArr.pop()
              if (idArr.join("_") == inputIdArr.join("_")) {
                id = item.id
                findEmptyInput = true
              }
            }

            if (findEmptyInput) {
              break
            }
          }
        }

        if (!findEmptyInput) {
          $("body").append(dom)
        }
      } else {
        $("body").append(dom)
      }

      return id
    }

    switch (data.certification_relation_type) {
      case "must":
        codeData = data.certification_codes[0]
        code = codeData.certification_code

        const images = codeData.images || []
        const firstImage = images[0] || {}

        if (typeof this.props.approvalStatusDisableEdit == "function") {
          editDisabled = this.props.approvalStatusDisableEdit(codeData.approval_status)
        } else {
          editDisabled = codeData.approval_status == 1
        }

        inputId = industryId + "_" + firstImage.id + "_" + Math.floor(100000 * Math.random())

        imgData = getMultiPageImgData(codeData.images)

        if (this.props.error && imgData.length == 0) {
          showError = true
        } else {
          showError = false
        }

        max = codeData.max_page_count

        // 可多页, 如果已通过审核，隐藏选项
        if (max && max > 1 && !editDisabled) {
          isMultiPage = true

          multiPageCheckComp = <Checkbox name="muti_page_check" className="check" label={"多页"} checked={firstImage.multiple || false} style={multiCheckBoxStyle} onChange={(event) => this.props.onChangeMultiple(industryId, code, firstImage.id, event.target.checked)} />
        }

        // 已通过审核的资质，不允许再添加
        if (editDisabled) {
          limit = 0
        } else {
          limit = isMultiPage && firstImage.multiple ? max : 1
        }

        inputId = appendInputDOM(inputId, code)

        subComponent.push(
          <ImageUploader
            key={industryId}
            {...imageUploaderProps}
            showError={showError}
            fileId={inputId}
            data={imgData}
            isRange={isRange}
            limit={limit}
            show={editDisabled}
            enlargeable={false}
            onFileChange={(e) => props.onUploaderFileChange(e, code, data, industryId)}
            onFileDelete={(name) => this.props.onUploaderFileDelete(name, code, industryId)}
          >
            <p className="w-normal">{codeData.certification_name}</p>
            <p>
              点击上传资质证件
              <br />
              {this.isSupportH5 ? "或把图片拖拽到此处" : ""}
            </p>
            <span className="des">(jpg/png,小于5MB)</span>
          </ImageUploader>
        )

        qualiInfoComponent.push(
          <div key={this.props.idx} className={(showError ? "has-error" : "") + " form-group"}>
            {this.props.hasLabel == false ? "" : <label className="control-label w-normal">{this.props.idx + 1 + ".请上传" + codeData.certification_name}</label>}
            {multiPageCheckComp}
            {subComponent}
            <span className="help-block">{showError ? "请上传资质" : ""}</span>
          </div>
        )
        break

      case "copy":
        codeData = data.certification_codes[0]
        code = codeData.certification_code

        let copyArray = []
        if (typeof this.props.approvalStatusDisableEdit == "function") {
          editDisabled = this.props.approvalStatusDisableEdit(codeData.approval_status)
        } else {
          editDisabled = codeData.approval_status == 1
        }

        const handlefuc = (i) => {
          copyArray.push(codeData.images[i] || {})
        }

        for (let i = 0; i < data.max_copy_count; i++) {
          handlefuc(i)
        }

        copyArray.map((item) => {
          imageData = item
          inputId = industryId + "_" + imageData.id + "_" + Math.floor(100000 * Math.random())
          imgData = getOneCertificationImgData(imageData)

          if (imgData.length == 0) {
            lack = true
          }

          max = codeData.max_page_count

          // 可多页
          if (max && max > 1 && !editDisabled) {
            isMultiPage = true

            multiPageCheckComp = (
              <Checkbox
                name={"muti_page_check_" + code}
                className="check"
                label={"多页"}
                checked={imageData.multiple || false}
                style={multiCheckBoxStyle}
                data-id={imageData.id}
                onChange={(event) => this.props.onChangeMultiple(industryId, code, event.target.parentNode.getAttribute("data-id") || imageData.id, event.target.checked)}
              />
            )
          }

          // 已通过审核的资质，不允许再添加
          if (editDisabled) {
            limit = 0
          } else {
            limit = isMultiPage && imageData.multiple ? max : 1
          }

          inputId = appendInputDOM(inputId, code)

          if (this.props.error && lack) {
            showError = true
          } else {
            showError = false
          }

          subComponent.push(
            <li className="copy-qualification">
              {multiPageCheckComp}
              <ImageUploader
                key={industryId}
                {...imageUploaderProps}
                fileId={inputId}
                data={imgData}
                isRange={isRange}
                show={editDisabled}
                limit={limit}
                enlargeable={false}
                onFileChange={(e) => props.onUploaderFileChange(e, code, data, industryId)}
                onFileDelete={(name) => this.props.onUploaderFileDelete(name, code, industryId)}
              >
                <p className="w-normal">{codeData.certification_name}</p>
                <p>
                  点击上传资质证件
                  <br />
                  {this.isSupportH5 ? "或把图片拖拽到此处" : ""}
                </p>
                <span className="des">(jpg/png,小于5MB)</span>
              </ImageUploader>
            </li>
          )
          return item
        })

        qualiInfoComponent.push(
          <div className={(showError ? "has-error" : "") + " form-group"}>
            <label className="control-label w-normal">{this.props.idx + 1 + ".请上传" + (data.min_copy_count == data.max_copy_count ? data.min_copy_count : data.min_copy_count + "至" + data.max_copy_count) + "份不同的" + codeData.certification_name}</label>
            <ul className={isMultiPage ? "" : "account-personal clearfix"}>{subComponent}</ul>
            <span className="help-block">{showError ? "请上传至少" + data.min_copy_count + "份资质" : ""}</span>
          </div>
        )
        break

      case "optional":
        lack = true

        data.certification_codes.map((item, i) => {
          const images = item.images || []
          const firstImage = images[0] || {}

          if (typeof this.props.approvalStatusDisableEdit == "function") {
            editDisabled = this.props.approvalStatusDisableEdit(item.approval_status)
          } else {
            editDisabled = item.approval_status == 1
          }

          code = item.certification_code
          inputId = industryId + "_" + (firstImage.id || "") + "_" + Math.floor(100000 * Math.random())

          imgData = getMultiPageImgData(images)

          // 选中的资质，看是否需要显示多页勾选
          if (code == data.code_checked) {
            max = item.max_page_count

            // 可多页
            if (max && max > 1 && !editDisabled) {
              isMultiPage = true

              multiPageCheckComp = (
                <Checkbox name={"muti_page_check_" + code} className="check" label={"多页"} checked={firstImage.multiple || false} style={multiCheckBoxStyle} onChange={(event) => this.props.onChangeMultiple(industryId, item.certification_code, firstImage.id, event.target.checked)} />
              )
            }
          }

          // 已通过审核的资质，不允许再添加
          if (editDisabled) {
            limit = 0
          } else {
            limit = isMultiPage && firstImage.multiple ? max : 1
          }

          inputId = appendInputDOM(inputId, code)

          if (code == data.code_checked && imgData.length > 0) {
            lack = false
          }

          subComponent.push(
            <Button key={item.certification_code} value={item.certification_code}>
              {item.certification_name}
            </Button>
          )

          if (this.props.error && lack) {
            showError = true
          } else {
            showError = false
          }

          subComponent2.push(
            <ImageUploader
              key={i}
              {...imageUploaderProps}
              fileId={inputId}
              panelId={"upload-panel-" + code}
              data={imgData}
              show={editDisabled}
              isRange={isRange}
              style={{ display: code == data.code_checked ? "block" : "none" }}
              limit={limit}
              enlargeable={false}
              onFileChange={(e) => this.props.onUploaderFileChange(e, item.certification_code, data, industryId)}
              onFileDelete={(name) => this.props.onUploaderFileDelete(name, item.certification_code, industryId)}
            >
              <p>
                点击上传资质证件
                <br />
                {this.isSupportH5 ? "或把图片拖拽到此处" : ""}
              </p>
              <span className="des">(jpg/png,小于5MB)</span>
            </ImageUploader>
          )
          return subComponent
        })

        qualiInfoComponent.push(
          <div key={this.props.idx} className={(showError ? "has-error" : "") + " form-group"}>
            <label className="control-label w-normal">{this.props.idx + 1 + ".请选择一种资质上传"}</label>
            <div>
              <span>
                <ButtonGroup value={data.code_checked} onChange={this.onChangeOptionalVal} activeDisplayType="primary">
                  {subComponent}
                </ButtonGroup>
              </span>
              {multiPageCheckComp}
            </div>
            {subComponent2}
            <span className="help-block">{showError ? "请选择一种资质上传" : ""}</span>
          </div>
        )
        break

      case "range":
        lack = true

        codeData = data.certification_codes[0]
        code = codeData.certification_code
        const randomNum = Math.floor(100000 * Math.random())

        if (typeof this.props.approvalStatusDisableEdit == "function") {
          editDisabled = this.props.approvalStatusDisableEdit(codeData.approval_status)
        } else {
          editDisabled = codeData.approval_status == 1
        }

        // 已通过审核的资质，不允许再添加
        if (editDisabled) {
          limit = 0
        } else {
          limit = data.max_copy_count
        }

        inputId = industryId + "_" + code + "_" + randomNum // 用于上传图片时找到对应的资质

        imgData = getImgData(codeData.images)

        if (imgData.length > 0) {
          lack = false
        }

        if (this.props.error && lack) {
          showError = true
        } else {
          showError = false
        }

        inputId = appendInputDOM(inputId, code)

        subComponent.push(
          <ImageUploader
            key={industryId}
            {...imageUploaderProps}
            fileId={inputId}
            limit={limit}
            show={editDisabled}
            data={imgData}
            isRange={isRange}
            enlargeable={false}
            onFileChange={(e) => this.props.onUploaderFileChange(e, code, data, industryId)}
            onFileDelete={(name) => this.props.onUploaderFileDelete(name, code, industryId)}
          >
            <p className="w-normal">{codeData.certification_name}</p>
            <p>
              点击上传资质证件
              <br />
              {this.isSupportH5 ? "或把图片拖拽到此处" : ""}
            </p>
            <span className="des">(jpg/png,小于5MB)</span>
          </ImageUploader>
        )

        qualiInfoComponent.push(
          <div key={this.props.idx} className={(showError ? "has-error" : "") + " form-group"}>
            {this.props.hasLabel == false ? "" : <label className="control-label w-normal">{this.props.idx + 1 + ".请上传至少" + codeData.min_page_count + "份" + codeData.certification_name}</label>}
            {subComponent}
            <span className="help-block">{showError ? "请上传至少" + codeData.min_page_count + "份资质" : ""}</span>
          </div>
        )
        break
      default:
        qualiInfoComponent.push(
          <div>
            <span>No type found</span>
          </div>
        )
        break
    }

    return qualiInfoComponent
  }

  render() {
    const res = this.genQualificationComp(this.props.data)
    return <div>{res}</div>
  }
}

QualificationUploader.propTypes = {
  data: PropTypes.object.isRequired, // qualification data
  industry_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // qualification's industry id
  idx: PropTypes.number.isRequired, // index of label text
  hasLabel: PropTypes.bool, //has label text or not
  error: PropTypes.bool, // has 'has-error' class or not
  onUploaderFileChange: PropTypes.func, // file change event cb
  onUploaderFileDelete: PropTypes.func, // file deletion event cb
  onChangeMultiple: PropTypes.func, // 改变勾选多页
}

export default QualificationUploader
